import {Injectable} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {AppConfigService} from '../app-config.service';
import {catchError, map} from 'rxjs/operators';
import {of} from 'rxjs';


export class UserDataDTO {
    name: string;
    middleName: string;
    firstName: string;
    lastName: string;
    email: string;
}
@Injectable({
    providedIn: 'root'
})

export class LoginFormService {

    private URLToken = '';
    private URLLoginForm = '';
    private companyName = '';
    private URLGetUserData = '';

    constructor(private http: HttpClient,
                private configService: AppConfigService) {
        this.URLToken = this.configService.getConfig().urlGetAccessToken;
        this.URLLoginForm = this.configService.getConfig().urlLoginForm;
        this.companyName = this.configService.getConfig().companyName;
        this.URLGetUserData = this.configService.getConfig().urlGetUserData;

    }

    getAccessToken(addresses: any) {
        if (localStorage.getItem('token')) {
            localStorage.removeItem('token');
        }
        const requestData = {
            ...addresses,
            companyName: this.configService.getConfig().companyName
        };

        console.log('validating user', requestData);
        console.log(this.URLToken);

        return this.http.post(`${this.URLToken}`, requestData, { responseType: 'text' }).pipe(
            map(response => {
                localStorage.setItem('token', response);
                console.log('response', response);
                return response;
            }),
            catchError(error => {
                console.error('Error:', error);
                return of(null);  // O cualquier valor por defecto que desees en caso de error
            })
        );
    }

    validateUser(email: string, token: string) {

        console.log('validating user', email, token);
        console.log(this.URLLoginForm);

        const params = new HttpParams()
            .set('email', email)
            .set('token', token)
            .set('company', this.companyName);

        return this.http.post(`${this.URLLoginForm}`, null, { params }).pipe(
            map(response => {
                localStorage.setItem('user', JSON.stringify(response));
                console.log('response', response);
                return response;
            }),
            catchError(error => {
                console.error('Error:', error);
                return of(null);  // O cualquier valor por defecto que desees en caso de error
            })
        );
    }

    getUserName(email: string, token: string) {

        console.log('validating user', email, token);
        console.log(this.URLLoginForm);

        const params = new HttpParams()
            .set('email', email)
            .set('token', token)
            .set('company', this.companyName);

        return this.http.get<UserDataDTO>(`${this.URLGetUserData}`, { params }).pipe(
            map(response => {
                localStorage.setItem('user', JSON.stringify(response));
                console.log('Nombre:', response.name);
                return response;
            }),
            catchError(error => {
                console.error('Error:', error);
                return of(null);
            })
        );

    }
}
